import type { DeleteAssessmentActivitiesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (
  deletedCount: number
): DeleteAssessmentActivitiesMutation => {
  return {
    delete_assessment_activity: {
      __typename: 'assessment_activity_mutation_response',
      affected_rows: deletedCount,
    },
  };
};

export const useDeleteAssessmentActivitiesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.assessment.deleteActivities.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.activityRegister.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.activityById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.assessment.assessmentActivitiesByParentId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.assessment.assessmentRCSAActivitiesByAssessmentId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.assessment.oversightActivityRegister.queryKey(),
        });
      },
    }),
  });

  return {
    deleteAssessmentActivities: async (variables: {
      Ids: string[];
    }): Promise<DeleteAssessmentActivitiesMutation> => {
      await mutation.mutateAsync(variables);

      // The data-layer throws NotFound when 0 rows are deleted, so a
      // successful response guarantees all requested IDs were deleted.
      return mapTrpcResponseToGraphQL(variables.Ids.length);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
